import React, { Component } from "react";
import { Box } from "reactjs-admin-lte";
import { Pagination, Form, FormGroup, Button } from "react-bootstrap";
import { momentHelper } from "../helpers";
import SelectDate from "component/element/SelectDate";
import Select from "react-select";
import PrintButtons from "component/element/PrintButtons";
import ReportStore from "stores/ReportStore";
import StockStore from "stores/StockStore";
import XLSX from "xlsx";
import FileSaver from "file-saver";
import FontAwesome from "react-fontawesome";
import DatePicker from "component/element/DatePicker";
import IframeModal from "component/element/IframeModal";
import Moment from "moment";
import "../report.css";
const WHOLE_YEAR = momentHelper.getMonth(); //'00'

class ReportStockMixPaint extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      activePage: 1,
      // groupId:'all',
      // groupList:[{label:'เลือกทั้งหมด',value:'all'}],
      month: WHOLE_YEAR,
      year: momentHelper.getYear(),
      data: [],
      isRange: false,
      day: momentHelper.getDay(),
      dayRange: momentHelper.getDay(),
      monthRange: WHOLE_YEAR,
      yearRange: momentHelper.getYear(),
    };
    this.refTableId = "ReportStockMixPaint-" + Math.ceil(Math.random() * 100);
  }

  componentDidMount() {}

  componentWillReceiveProps(newProps) {
    if (newProps.show && newProps.show !== this.props.show) {
      this.loadData(this.state.year, this.state.month, this.state.day);
      // this.loadCategory()
    }
  }

  getNumberFormat(value) {
    let _val =
      value === "" || value === null || value === undefined || isNaN(value)
        ? 0
        : value;
    _val = parseFloat(_val);
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth();
    if (all_day) {
      if (all_day < this.state.day) {
        var defaultDay = "00";
      } else {
        var defaultDay = this.state.day;
      }
    } else {
      var defaultDay = "00";
    }
    return defaultDay;
  }

  loadData(year = "", month = "", day = "") {
    this.setState({ loading: false });
    ReportStore.loadMixPaintList(year, month, day, "", "", "", "", (result) => {
      this.setState({ loading: false, data: result.data });
    });
  }

  loadDataRange(start = "", end = "") {
    ReportStore.loadMixPaintListRange(start, end, "", "", "", "", (result) => {
      this.setState({ loading: false, data: result.data });
    });
  }

  //   loadCategory() {
  //       let groupList = [{label:'เลือกทั้งหมด',value:'all'}]
  //       StockStore.loadCategory('officemate',(result)=>{
  //         result.data.forEach((item,index)=>{
  //             groupList.push({label:item.name,value:item.cat_id})
  //         })
  //         this.setState({groupList:groupList})
  //       })
  //   }

  renderBody() {
    let { data } = this.state;
    if (data.length == 0) {
      return (
        <tr>
          <td colSpan={10}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return data.map((item, index) => (
        <tr key={index}>
          <td className="text-left">{item.doc_date}</td>
          <td className="text-left">{item.mixpaint_no}</td>
          <td className="text-left">{item.work_no}</td>
          <td className="text-left">{item.car_registration_no}</td>
          <td className="text-left">{item.brand}</td>
          <td className="text-left">{item.model}</td>
          <td className="text-left">{item.mixed_by}</td>
          <td className="text-left">{item.request_by}</td>
          <td className="text-left">{item.colorcode}</td>
          <td className="text-left">{item.description}</td>
        </tr>
      ));
    }
  }

  getDate() {
    let {
      day,
      year,
      month,
      isRange,
      dayRange,
      monthRange,
      yearRange,
    } = this.state;
    if (isRange) {
      let start =
        (day < 10 ? "0" + day : day) +
        "/" +
        (month == "00" ? "1" : month) +
        "/" +
        year;
      let end =
        dayRange +
        "/" +
        (monthRange < 10 ? "0" + monthRange : monthRange) +
        "/" +
        yearRange;
      return "ประจำวันที่ " + start + " - " + end;
    } else {
      let text = "ประจำวันที่ ";
      text += day + " " + momentHelper.getMonthText(month) + " " + year;
      if (year === "0" || year === "00" || year === 0) {
        text = "ทั้งหมด";
      } else if (month === "0" || month === "00" || month === 0) {
        text = "ประจำปี " + year;
      } else if (day === "0" || day === "00" || day === 0) {
        text = "ประจำเดือน " + momentHelper.getMonthText(month) + " " + year;
      }
      return text;
    }
  }

  renderTable() {
    return (
      <div className="display-overflow">
        <table
          id={this.refTableId}
          className="table table-responsive table-hover table-bordered-solid"
          style={{ minWidth: "1400px" }}
        >
          <thead>
            <tr>
              <th
                style={{ display: "none" }}
                className="text-center"
                colSpan={9}
              >
                รายงานการเบิกแม่สีผสม {this.getDate()}
              </th>
            </tr>
            <tr>
              <th className="text-center" style={{ width: "150px" }}>
                วันที่เบิก
              </th>
              <th className="text-center" style={{ width: "100px" }}>
                เอกสารที่
              </th>
              <th className="text-center" style={{ width: "150px" }}>
                ใบงานซ่อม
              </th>
              <th className="text-center" style={{ width: "150px" }}>
                ทะเบียนรถ
              </th>
              <th className="text-center" style={{ width: "150px" }}>
                ยี่ห้อ
              </th>
              <th className="text-center" style={{ width: "150px" }}>
                รุ่น
              </th>
              <th className="text-center" style={{ width: "150px" }}>
                ช่างผสมสี
              </th>
              <th className="text-center" style={{ width: "150px" }}>
                ช่างเบิก
              </th>
              <th className="text-center" style={{ width: "150px" }}>
                รหัสสี
              </th>
              <th className="text-center" style={{ width: "150px" }}>
                อธิบาย (หมายเหตุ)
              </th>
            </tr>
          </thead>
          <tbody>{this.renderBody()}</tbody>
          <tfoot>
            <tr>
              <th className="text-center">วันที่เบิก</th>
              <th className="text-center">เอกสารที่</th>
              <th className="text-center">ใบงานซ่อม</th>
              <th className="text-center">ทะเบียนรถ</th>
              <th className="text-center">ยี่ห้อ</th>
              <th className="text-center">รุ่น</th>
              <th className="text-center">ช่างผสมสี</th>
              <th className="text-center">ช่างเบิก</th>
              <th className="text-center">รหัสสี</th>
              <th className="text-center" style={{ width: "150px" }}>
                อธิบาย (หมายเหตุ)
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey,
    });
    // next... load new page
  }

  //   onGroupChange(val) {
  //     this.setState({
  //       groupId: val.value
  //     })
  //     this.loadData(val.value)
  //   }

  onDayChange(val) {
    this.setState({
      day: val.value,
      isRange: false,
    });
    this.loadData(this.state.year, this.state.month, val.value);
  }

  onMonthChange(val) {
    let date = this.state.year - 543 + "-" + val.value;
    let _day = "00";
    _day = this.getAllDayOfMonth(date);
    this.setState({
      month: val.value,
      isRange: false,
      day: _day,
    });
    this.loadData(this.state.year, val.value, _day);
  }

  onYearChange(val) {
    let date = val.value - 543 + "-" + this.state.month;
    let _day = "00";
    _day = this.getAllDayOfMonth(date);
    this.setState({
      year: val.value,
      isRange: false,
      day: _day,
    });
    this.loadData(val.value, this.state.month, _day);
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(
      document.getElementById(this.refTableId)
    );
    let wbout = XLSX.write(worksheet, {
      bookType: "xlsx",
      bookSST: true,
      type: "binary",
    });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    }
    const fileName = "รายงานการเบิกแม่สีผสม.xlsx";
    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
      fileName
    );
    this.setState({ showExport: false });
  }

  onPrintTable(e) {
    const { isRange } = this.state;
    let url = "";
    let param =
      "PrintReportStockMixPaint&year=" +
      this.state.year +
      "&month=" +
      this.state.month +
      "&day=" +
      this.state.day +
      "&isRange=false";
    if (isRange) {
      let { day, month, year, dayRange, monthRange, yearRange } = this.state;
      let start =
        day + "/" + (month == "00" ? "1" : month) + "/" + (year - 543);
      let end = dayRange + "/" + monthRange + "/" + (yearRange - 543);
      param =
        "PrintReportStockMixPaint&start_date=" +
        start +
        "&end_date=" +
        end +
        "&isRange=true";
    }

    if (process.env.NODE_ENV == "development") {
      url = "./?startPage=" + param;
    } else {
      url = "./pdf/v2/?startPage=" + param;
    }
    this.refs.iframe.loadUrl(url);
  }

  onStartDateRangeChange(time) {
    if (time != "" && time != undefined && time != null) {
      let _day = time.substr(0, 2);
      let _month = time.substr(3, 2);
      let _year = time.substr(6, 10);
      this.setState({
        day: _day * 1,
        month: _month,
        year: _year * 1,
        isRange: false,
      });
      this.loadData(_year, _month, _day);
    }
  }

  onEndDateRangeChange(time) {
    if (time != "" && time != undefined && time != null) {
      let { day, month, year } = this.state;
      let _day = parseInt(time.substr(0, 2));
      let _month = parseInt(time.substr(3, 5));
      let _year = parseInt(time.substr(6, 10));
      this.setState({
        isRange: true,
        dayRange: _day,
        monthRange: _month,
        yearRange: _year,
      });
      year = year - 543;
      _year = _year - 543;
      let start = day + "/" + (month == "00" ? "1" : month) + "/" + year;
      let end = _day + "/" + _month + "/" + _year;
      this.loadDataRange(start, end);
    }
  }

  onRangeChange(fromDateString, toDateString, items) {
    let { day, month, year, dayRange, monthRange, yearRange } = this.state;
    day = items.from.format("DD") * 1;
    month = items.from.format("MM");
    year = items.from.format("YYYY") * 1 + 543;
    dayRange = items.to.format("DD") * 1;
    monthRange = items.to.format("MM");
    yearRange = items.to.format("YYYY") * 1 + 543;
    this.setState({
      isRange: true,
      day: day,
      month: month,
      year: year,
      dayRange: dayRange,
      monthRange: monthRange,
      yearRange: yearRange,
    });
    const start = day + "/" + month + "/" + items.from.format("YYYY");
    const end = dayRange + "/" + monthRange + "/" + items.to.format("YYYY");
    this.loadDataRange(start, end);
  }

  renderWCalendar() {
    return (
      <div style={{ display: "inline-flex" }}>
        <DatePicker
          style={{ display: "inline-block" }}
          height={"36px"}
          none={true}
          showIcon={true}
          showFooter={true}
          popPlacement="bottom"
          buddhistEra
          value={
            (this.state.day == "00" ? momentHelper.getDay() : this.state.day) +
            "/" +
            (this.state.month == "00" ? WHOLE_YEAR : this.state.month) +
            "/" +
            this.state.year
          }
          onChange={this.onStartDateRangeChange.bind(this)}
          maxWidth={"100%"}
          onRangeChange={this.onRangeChange.bind(this)}
        />
        <DatePicker
          style={{ display: "inline-block" }}
          height={"36px"}
          none={true}
          showIcon={true}
          showFooter={true}
          popPlacement="bottom"
          buddhistEra
          value={
            (this.state.dayRange == "00"
              ? momentHelper.getDay()
              : this.state.dayRange) +
            "/" +
            (this.state.monthRange == "00"
              ? WHOLE_YEAR
              : this.state.monthRange) +
            "/" +
            this.state.yearRange
          }
          onChange={this.onEndDateRangeChange.bind(this)}
          maxWidth={"100%"}
          onRangeChange={this.onRangeChange.bind(this)}
        />
      </div>
    );
  }

  renderToolbar() {
    return (
      <Form inline style={{ marginBottom: "5px" }}>
        <FormGroup style={{ verticalAlign: "top" }}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>
        <FormGroup
          style={{
            verticalAlign: "top",
            marginLeft: "5px",
            marginTop: "1.5px",
          }}
        >
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft="0"
            width="auto"
          />
        </FormGroup>
      </Form>
    );
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)}
        />
      </div>
    );
  }

  getStartDateRangeText() {
    let { day, month, year } = this.state;
    let txtMonth = momentHelper.getMonthText(month.toString());
    return day * 1 + " " + txtMonth + " " + year;
  }

  getEndDateRangeText() {
    let { dayRange, monthRange, yearRange } = this.state;
    dayRange = dayRange == 0 ? 1 : dayRange;
    let txtMonth = momentHelper.getMonthText(monthRange.toString());
    return dayRange + " " + txtMonth + " " + yearRange;
  }

  onRangeClearClick() {
    this.loadData(this.state.year, this.state.month, this.state.day);
    this.setState({
      isRange: false,
      dayRange: momentHelper.getDay(),
      monthRange: this.state.month,
      yearRange: this.state.year,
    });
  }

  renderDateRange() {
    let { isRange } = this.state;
    if (isRange) {
      return (
        <div style={{ marginBottom: "10px", display: "flex" }}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;
          <Button
            className="btn btn-xs"
            onClick={this.onRangeClearClick.bind(this)}
          >
            <FontAwesome name="eraser" />
            &nbsp;ลบช่วงเวลา
          </Button>
        </div>
      );
    } else {
      return "";
    }
  }

  render() {
    const { loading } = this.state;
    return (
      <Box loading={loading}>
        <Box.Header border={true}>{this.props.renderMenu()}</Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderDateRange()}
          {this.renderTable()}
          {/*this.renderPaging()*/}
          <IframeModal ref="iframe" title={"พิมพ์เอกสาร"} />
        </Box.Body>
      </Box>
    );
  }
}

ReportStockMixPaint.defaultProps = {
  show: false,
};

export default ReportStockMixPaint;



// WEBPACK FOOTER //
// ./src/view/report/material/ReportStockMixPaint.js